import { QueryCache, QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'
import { toast } from '~/ui/toast'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: true,
      retry: (count, error) =>
        !(error instanceof ApiError && error.status < 500) && count < 2,
    },
    mutations: {
      onError: (error) => toast.error(error instanceof ApiError ? error.message : 'Speichern fehlgeschlagen.'),
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Background refetch failures of data already on screen: one quiet toast, no error page.
      if (query.state.data !== undefined && !(error instanceof ApiError && error.status === 401))
        toast.error('Aktualisieren fehlgeschlagen. Die Anzeige ist evtl. nicht aktuell.')
    },
  }),
})
